export const SAT_BASE_URL = "https://api.n2yo.com/rest/v1/satellite";
export const STARLINK_CATEGORY = "52";
export const SAT_API_KEY = "3JZ6TV-L4TVV9-VXKYJN-4NWD";
export const NEARBY_SATELLITE = "above";
export const SATELLITE_POSITION_URL = "positions";

export const WORLD_MAP_URL = "https://unpkg.com/world-atlas@1/world/110m.json";

export const PERSONAL_PROXY = "https://webhooks.utils.click/proxy";
// export const PERSONAL_PROXY = "http://localhost:8081/proxy";
